import { c as _c } from "react/compiler-runtime";
const Ended = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m11.97 5.443.708-.707-1.414-1.414-.707.707L8 6.586 5.443 4.029l-.707-.707-1.414 1.414.707.707L6.586 8l-2.557 2.556-.707.708 1.415 1.414.707-.707L8 9.414l2.556 2.557.708.707 1.414-1.415-.707-.707L9.414 8l2.557-2.557Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Ended;